import React, { useState } from 'react';
import apiService from '../services/apiService';
import { dataHoraBR } from './TelegramFeedbackFields';

/**
 * Estado de acesso do usuário nas telas de edição (vendedor e chefia): bloqueio por excesso
 * de senhas erradas, com o botão de desbloquear, e o último login.
 *
 * Os dados vêm da foto da listagem (`location.state`), então depois de desbloquear o estado
 * local é que manda — a tela não recarrega o usuário sozinha. A listagem rebusca da API ao
 * voltar.
 *
 * Os campos (`is_locked`, `locked_until`, `last_login_*`, `last_lockout_*`) vêm de
 * /listusers e /liststoresbyuser da recorder-api, em ISO UTC com `Z`.
 */
const LoginAccessStatus = ({ user }) => {
    const [bloqueado, setBloqueado] = useState(!!user?.is_locked);
    const [desbloqueando, setDesbloqueando] = useState(false);
    const [aviso, setAviso] = useState({ type: '', text: '' });

    if (!user?.user_id) return null;

    const desbloquear = async () => {
        setAviso({ type: '', text: '' });
        setDesbloqueando(true);
        try {
            const res = await apiService.unlockUser(user.user_id);
            if (res.success) {
                setBloqueado(false);
                setAviso({ type: 'success', text: 'Login desbloqueado. A pessoa já pode entrar.' });
            } else {
                setAviso({ type: 'error', text: res.message || 'Não foi possível desbloquear.' });
            }
        } finally {
            setDesbloqueando(false);
        }
    };

    const ultimoLogin = user.last_login_at
        ? `${dataHoraBR(user.last_login_at)}${user.last_login_ip ? ` · IP ${user.last_login_ip}` : ''}`
        : 'nenhum registrado';
    const ultimoBloqueio = user.last_lockout_at
        ? `${dataHoraBR(user.last_lockout_at)}${user.last_lockout_ip ? ` · IP ${user.last_lockout_ip}` : ''}`
        : null;

    return (
        <div className="form-group login-acesso">
            <label>Acesso</label>
            {bloqueado && (
                <div className="login-bloqueio">
                    <div>
                        <strong>Login bloqueado até {dataHoraBR(user.locked_until)}</strong> por
                        excesso de senhas erradas
                        {user.last_lockout_ip ? <> (tentativa vinda do IP {user.last_lockout_ip})</> : null}.
                    </div>
                    <button type="button" className="btn btn-danger" onClick={desbloquear} disabled={desbloqueando}>
                        {desbloqueando ? 'Desbloqueando...' : 'Desbloquear agora'}
                    </button>
                </div>
            )}
            {aviso.text && <div className={`alert alert-${aviso.type}`}>{aviso.text}</div>}
            <small className="field-hint">
                Último login: {ultimoLogin}.
                {!bloqueado && ultimoBloqueio && <> Último bloqueio: {ultimoBloqueio}.</>}
                {bloqueado && <> Definir uma nova senha abaixo também desbloqueia.</>}
            </small>
        </div>
    );
};

export default LoginAccessStatus;
